module.exports = __webpack_public_path__ + "img/top-up-card.3b1e1326.svg";